import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import MainLayout from './components/MainLayout';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import UserList from './pages/User/UserList';
import UserForm from './pages/User/UserForm';
import PermissionManagement from './pages/User/Permissions';
import PersonalPermissionsManagement from './pages/User/PersonalPermissions';
import PersonalPermissionEdit from './pages/User/PersonalPermissions/Edit';
import UserMonitoring from './pages/User/UserMonitoring';
import ChangePassword from './pages/User/ChangePassword';
import PermissionDemo from './pages/PermissionDemo';
import TestPermissionV2 from './pages/TestPermissionV2';
import DebugPermissions from './pages/DebugPermissions';
import MekakPage from './pages/Mekak/MekakPage';
import KnowledgeForm from './pages/Mekak/KnowledgeForm';
import KnowledgeDetail from './pages/Mekak/KnowledgeDetail';
import FileDocumentDetail from './pages/Mekak/FileDocumentDetail';
import ERPHome from './pages/ERP/ERPHome';
import SCForm from './pages/SC/SCForm';
import ProductGradeForm from './pages/ProductGrade/ProductGradeForm';
import N102Form from './pages/N102/N102Form';
import B151Form from './pages/B151/B151Form';
import D103Form from './pages/D103/D103Form';
import ExchangeRateForm from './pages/ExchangeRate/ExchangeRateForm';
import M101Form from './pages/M101/M101Form';
import P1104Form from './pages/P1104/P1104Form';
import M104Form from './pages/M104/M104Form';
import P1106Form from './pages/P1106/P1106Form';
import P1113Form from './pages/P1113/P1113Form';
import P1117Form from './pages/P1117/P1117Form';
import P111HForm from './pages/P111H/P111HForm';
import P1306Form from './pages/P1306/P1306Form';
import P9137Form from './pages/P9137/P9137Form';
import P910TForm from './pages/P910T/P910TForm';
import P110CForm from './pages/P110C/P110CForm';
import P913DForm from './pages/P913D/P913DForm';
import P9136Form from './pages/P9136/P9136Form';
import N101Form from './pages/N101/N101Form';
import L102Form from './pages/L102/L102Form';
import M105Form from './pages/M105/M105Form';
import P9138Form from './pages/P9138/P9138Form';
import P151Form from './pages/P151/P151Form';
import P9132Form from './pages/P9132/P9132Form';
import P9108Form from './pages/P9108/P9108Form';
import P111GForm from './pages/P111G/P111GForm';
import P111AForm from './pages/P111A/P111AForm';
import P910GForm from './pages/P910G/P910GForm';
import P910JForm from './pages/P910J/P910JForm';
import P110HForm from './pages/P110H/P110HForm';
import P9103Form from './pages/P9103/P9103Form';
import P910QForm from './pages/P910Q/P910QForm';
import P1311Form from './pages/P1311/P1311Form';
import P1111Form from './pages/P1111/P1111Form';
import P1116Form from './pages/P1116/P1116Form';
import D318Report from './pages/D318/D318Report';
import C322Report from './pages/C322/C322Report';
import D319Form from './pages/D319/D319Form';
import P1308Report from './pages/P1308/P1308Report';
import C5M5Form from './pages/C5M5/C5M5Form';
import C502Approval from './pages/C502/C502Approval';
import C504Approval from './pages/C504/C504Approval';
import C514Approval from './pages/C514/C514Approval';
import C5M4Writeoff from './pages/C5M4/C5M4Writeoff';
import C5N4Writeoff from './pages/C5N4/C5N4Writeoff';
import D506Approval from './pages/D506/D506Approval';
import C5M2Form from './pages/C5M2/C5M2Form';
import ApprovalList from './pages/Approval/ApprovalList';
import D501Form from './pages/D501/D501Form';
import DevDashboard from './pages/DevDashboard';
import ModuleFlowPage from './pages/ModuleFlow/ModuleFlowPage';
import CostCalculator from './pages/CostCalculator/CostCalculator';
import J5N5Reversal from './pages/J5N5/J5N5Reversal';
import J5N8Reversal from './pages/J5N8/J5N8Reversal';
import P9513Form from './pages/P9513/P9513Form';
import P1314Report from './pages/P1314/P1314Report';
import C330Form from './pages/C330/C330Form';
import P15MHApproval from './pages/P15MH/P15MHApproval';
import P15MJApproval from './pages/P15MJ/P15MJApproval';
import P9410Form from './pages/P9410/P9410Form';
import D5M2Reversal from './pages/D5M2/D5M2Reversal';
import { d5n2Api } from './services/d5m2Api';
import C516Form from './pages/C516/C516Form';
import C5N6Form from './pages/C5N6/C5N6Form';
import R5D6Reversal from './pages/R5D6/R5D6Reversal';
import { d5m6Api } from './services/r5d6Api';
import C526Form from './pages/C526/C526Form';
import D502Form from './pages/D502/D502Form';
import T102Form from './pages/T102/T102Form';
import T202Form from './pages/T202/T202Form';
import N202Form from './pages/N202/N202Form';
import R5M3Form from './pages/R5M3/R5M3Form';
import T5M2Form from './pages/T5M2/T5M2Form';
import T402Form from './pages/T402/T402Form';
import M201Form from './pages/M201/M201Form';
import M207Form from './pages/M207/M207Form';
import T206Form from './pages/T206/T206Form';
import R5D5Form from './pages/R5D5/R5D5Form';
import R211Form from './pages/R211/R211Form';
import M302Form from './pages/M302/M302Form';
import M310Form from './pages/M310/M310Form';
import M303Form from './pages/M303/M303Form';
import N351Form from './pages/N351/N351Form';
import R5M8Form from './pages/R5M8/R5M8Form';
import N501Form from './pages/N501/N501Form';
import N502Form from './pages/N502/N502Form';
import N503Form from './pages/N503/N503Form';
import M5M3Form from './pages/M5M3/M5M3Form';
import M203Form from './pages/M203/M203Form';
import M503Form from './pages/M503/M503Form';
import P201Form from './pages/P201/P201Form';
import R5NPForm from './pages/R5NP/R5NPForm';
import M5M1Form from './pages/M5M1/M5M1Form';
import M5M8Form from './pages/M5M8/M5M8Form';
import N5P1Form from './pages/N5P1/N5P1Form';
import R5D2Reversal from './pages/R5D2/R5D2Reversal';
import P503Form from './pages/P503/P503Form';
import P5M3Form from './pages/P5M3/P5M3Form';
import M301Form from './pages/M301/M301Form';
import M305Form from './pages/M305/M305Form';
import N5M3Form from './pages/N5M3/N5M3Form';
import M209Form from './pages/M209/M209Form';
import J501Form from './pages/J501/J501Form';
import J514Form from './pages/J514/J514Form';
import PW030AForm from './pages/PW030A/PW030AForm';
import PW0308Form from './pages/PW0308/PW0308Form';
import P203Form from './pages/P203/P203Form';
import J5N4Form from './pages/J5N4/J5N4Form';
import J5M3Form from './pages/J5M3/J5M3Form';
import J5M8Form from './pages/J5M8/J5M8Form';
import J5M1Form from './pages/J5M1/J5M1Form';
import L303Form from './pages/L303/L303Form';
import L313Form from './pages/L313/L313Form';
import J30CForm from './pages/J30C/J30CForm';
import M106Form from './pages/M106/M106Form';
import PW1115F1Form from './pages/PW1115F1/PW1115F1Form';
import PW910CF1Form from './pages/PW910CF1/PW910CF1Form';
import PW0113F1Form from './pages/PW0113F1/PW0113F1Form';
import J515Form from './pages/J515/J515Form';
import L402Form from './pages/L402/L402Form';
import L413Form from './pages/L413/L413Form';
import L202Form from './pages/L202/L202Form';
import J207Form from './pages/J207/J207Form';
import J201Form from './pages/J201/J201Form';
import J202Form from './pages/J202/J202Form';
import J502Form from './pages/J502/J502Form';
import J208Form from './pages/J208/J208Form';
import J212Form from './pages/J212/J212Form';
import J219Form from './pages/J219/J219Form';
import J214Form from './pages/J214/J214Form';
import D5M4Form from './pages/D5M4/D5M4Form';
import { d5n4Api } from './services/d5m4Api';
import D5M3Form from './pages/D5M3/D5M3Form';
import D5M1Form from './pages/D5M1/D5M1Form';
import J5M2Form from './pages/J5M2/J5M2Form';
import J203Form from './pages/J203/J203Form';
import P1105Form from './pages/P1105/P1105Form';
import P1114Form from './pages/P1114/P1114Form';
import PRDForm from './pages/PRD/PRDForm';
import P1103Form from './pages/P1103/P1103Form';
import P9101Form from './pages/P9101/P9101Form';
import CUSForm from './pages/CUS/CUSForm';
import PWC201F1Form from './pages/PWC201F1/PWC201F1Form';
import PW9220Form from './pages/PW9220/PW9220Form';
import PW9221F1Form from './pages/PW9221F1/PW9221F1Form';
import PW9224Form from './pages/PW9224/PW9224Form';
import PW9236F1Form from './pages/PW9236F1/PW9236F1Form';
import PW9204F1Form from './pages/PW9204F1/PW9204F1Form';
import N103Form from './pages/N103/N103Form';
import P111Form from './pages/P111/P111Form';
import P1112Form from './pages/P1112/P1112Form';
import P9133Form from './pages/P9133/P9133Form';
import P111JForm from './pages/P111J/P111JForm';
import P111KForm from './pages/P111K/P111KForm';
import P9106Form from './pages/P9106/P9106Form';
import P9105Form from './pages/P9105/P9105Form';
import P9102Form from './pages/P9102/P9102Form';
import P910HForm from './pages/P910H/P910HForm';
import PW9210F1Form from './pages/PW9210F1/PW9210F1Form';
import PW2204F1Form from './pages/PW2204F1/PW2204F1Form';
import G103Form from './pages/G103/G103Form';
import P0107Form from './pages/P0107/P0107Form';
import Chain29VoucherForm from './pages/AccountingVoucher/Chain29VoucherForm';
import M208Form from './pages/M208/M208Form';
import M206Form from './pages/M206/M206Form';
import J228Form from './pages/J228/J228Form';
import P9234Form from './pages/P9234/P9234Form';
import J215Form from './pages/J215/J215Form';
import P9232Form from './pages/P9232/P9232Form';
import G209Form from './pages/G209/G209Form';
import C203Form from './pages/C203/C203Form';
import C204Form from './pages/C204/C204Form';
import C205Form from './pages/C205/C205Form';
import D201Form from './pages/D201/D201Form';
import FinBillDataForm from './pages/FinBillData/FinBillDataForm';
import PW9213Form from './pages/PW9213/PW9213Form';
import PW9119Form from './pages/PW9119/PW9119Form';
import PW9205Form from './pages/PW9205/PW9205Form';
import PW9233Form from './pages/PW9233/PW9233Form';
import PW9201Form from './pages/PW9201/PW9201Form';
import PW933AForm from './pages/PW933A/PW933AForm';
import PW9334Form from './pages/PW9334/PW9334Form';
import G306Form from './pages/G306/G306Form';
import G319Form from './pages/G319/G319Form';
import H301Form from './pages/H301/H301Form';
import H303Form from './pages/H303/H303Form';
import H311Form from './pages/H311/H311Form';
import H312Form from './pages/H312/H312Form';
import PW9335Form from './pages/PW9335/PW9335Form';
import PW9336Form from './pages/PW9336/PW9336Form';
import PW9337Form from './pages/PW9337/PW9337Form';
import PW9339Form from './pages/PW9339/PW9339Form';
import PW933BForm from './pages/PW933B/PW933BForm';
import PW9341Form from './pages/PW9341/PW9341Form';
import P9311Form from './pages/P9311/P9311Form';
import P9315Form from './pages/P9315/P9315Form';
import PWD310Form from './pages/PWD310/PWD310Form';
import PW9614Form from './pages/PW9614/PW9614Form';
import PW9531Form from './pages/PW9531/PW9531Form';
import PWJ310Form from './pages/PWJ310/PWJ310Form';
import PWP303Form from './pages/PWP303/PWP303Form';
import PW2501Form from './pages/PW2501/PW2501Form';
import PW9403Form from './pages/PW9403/PW9403Form';
import PW930BForm from './pages/PW930B/PW930BForm';
import P9301Form from './pages/P9301/P9301Form';
import P930HForm from './pages/P930H/P930HForm';
import PW9321Form from './pages/PW9321/PW9321Form';
import PW9304Form from './pages/PW9304/PW9304Form';
import P9306Form from './pages/P9306/P9306Form';
import P9310Form from './pages/P9310/P9310Form';
import PW150KForm from './pages/PW150K/PW150KForm';
import PWG332Form from './pages/PWG332/PWG332Form';
import PW150HForm from './pages/PW150H/PW150HForm';
import PW1315Form from './pages/PW1315/PW1315Form';
import PW1313Form from './pages/PW1313/PW1313Form';
import PW1312Form from './pages/PW1312/PW1312Form';
import PW98M2Form from './pages/PW98M2/PW98M2Form';
import PWC301Form from './pages/PWC301/PWC301Form';
import PWG501Form from './pages/PWG501/PWG501Form';
import PWD512Form from './pages/PWD512/PWD512Form';
import PWR5J3Form from './pages/PWR5J3/PWR5J3Form';
import PW9411Form from './pages/PW9411/PW9411Form';
import PWL304Form from './pages/PWL304/PWL304Form';
import PWJ5M7Form from './pages/PWJ5M7/PWJ5M7Form';
import PWJ508Form from './pages/PWJ508/PWJ508Form';
import PW9314Form_Report from './pages/PW9314/PW9314Form';
import PW9318Form from './pages/PW9318/PW9318Form';
import PW9319Form from './pages/PW9319/PW9319Form';
import PWG302Form from './pages/PWG302/PWG302Form';
import G303Form from './pages/G303/G303Form';
import PWG304Form from './pages/PWG304/PWG304Form';
import PWJ324Form from './pages/PWJ324/PWJ324Form';
import PWJ308Form from './pages/PWJ308/PWJ308Form';
import PW9312Form from './pages/PW9312/PW9312Form';
import PW9322Form from './pages/PW9322/PW9322Form';
import PWD307Form from './pages/PWD307/PWD307Form';
import PWD308Form from './pages/PWD308/PWD308Form';
import PWJ30AForm from './pages/PWJ30A/PWJ30AForm';
import PWJ30BForm from './pages/PWJ30B/PWJ30BForm';
import PW98M5Form from './pages/PW98M5/PW98M5Form';
import PWC512Form from './pages/PWC512/PWC512Form';
import PWD503Form from './pages/PWD503/PWD503Form';
import PWR5C4Form from './pages/PWR5C4/PWR5C4Form';
import PWC505Form from './pages/PWC505/PWC505Form';
import C505Form from './pages/C505/C505Form';
import D504Form from './pages/D504/D504Form';
import { d514Api } from './services/d504Api';
import {
  pwd514f1AcceptanceManifest,
  pwd5m6f1AcceptanceManifest,
  pwd5n2f1AcceptanceManifest,
  pwd5n4f1AcceptanceManifest,
} from './features/acceptance';
import PWH508Form from './pages/PWH508/PWH508Form';
import PWH5M8Form from './pages/PWH5M8/PWH5M8Form';
import PWG5M5Form from './pages/PWG5M5/PWG5M5Form';
import PWG5M1Form from './pages/PWG5M1/PWG5M1Form';
import PWG504Form from './pages/PWG504/PWG504Form';
import PWG5M4Form from './pages/PWG5M4/PWG5M4Form';
import PWG5M8Form from './pages/PWG5M8/PWG5M8Form';
import PWJ503Form from './pages/PWJ503/PWJ503Form';
import PWN511Form from './pages/PWN511/PWN511Form';
import PWN5MAForm from './pages/PWN5MA/PWN5MAForm';
import PWN5N1Form from './pages/PWN5N1/PWN5N1Form';
import PWN5MBForm from './pages/PWN5MB/PWN5MBForm';
import L205Form from './pages/L205/L205Form';
import L204Form from './pages/L204/L204Form';
import L316Form from './pages/L316/L316Form';
import M309Form from './pages/M309/M309Form';
import N301Form from './pages/N301/N301Form';
import N211Form from './pages/N211/N211Form';
import D301Form from './pages/D301/D301Form';
import C358Form from './pages/C358/C358Form';
import D324Form from './pages/D324/D324Form';
import H302Form from './pages/H302/H302Form';
import C304Form from './pages/C304/C304Form';
import P1304Form from './pages/P1304/P1304Form';
import G305Form from './pages/G305/G305Form';
import C324Form from './pages/C324/C324Form';
import D302Form from './pages/D302/D302Form';
import D312Form from './pages/D312/D312Form';
import D314Form from './pages/D314/D314Form';
import D303Form from './pages/D303/D303Form';
import D304Form from './pages/D304/D304Form';
import D305Form from './pages/D305/D305Form';
import C305Form from './pages/C305/C305Form';
import PWC315Form from './pages/PWC315/PWC315Form';
import D306Form from './pages/D306/D306Form';
import D309Form from './pages/D309/D309Form';
import D313Form from './pages/D313/D313Form';
import D320Form from './pages/D320/D320Form';
import D328Form from './pages/D328/D328Form';
import P131KForm from './pages/P131K/P131KForm';
import PW9324Form from './pages/PW9324/PW9324Form';
import PW9404Form from './pages/PW9404/PW9404Form';
import PW9701Form from './pages/PW9701/PW9701Form';
import M501Form from './pages/M501/M501Form';
import D203Form from './pages/D203/D203Form';
import D202Form from './pages/D202/D202Form';
import Pwd210Form from './pages/Pwd210/Pwd210Form';
import Pwd216Form from './pages/Pwd216/Pwd216Form';
import Pwd217Form from './pages/Pwd217/Pwd217Form';
import D204Form from './pages/D204/D204Form';
import D206Form from './pages/D206/D206Form';
import D211Form from './pages/D211/D211Form';
import PWD212Form from './pages/PWD212/PWD212Form';
import PWG208Form from './pages/PWG208/PWG208Form';
import G204Form from './pages/G204/G204Form';
import C209Form from './pages/C209/C209Form';
import C212Form from './pages/C212/C212Form';
import P2201Form from './pages/P2201/P2201Form';
import PW2202Form from './pages/PW2202/PW2202Form';
import J209Form from './pages/J209/J209Form';
import J218Form from './pages/J218/J218Form';
import T207Form from './pages/T207/T207Form';
import T20AForm from './pages/T20A/T20AForm';
import P922AForm from './pages/P922A/P922AForm';
import P9207Form from './pages/P9207/P9207Form';
import P9209Form from './pages/P9209/P9209Form';
import PW220AForm from './pages/PW220A/PW220AForm';
import PWH203Form from './pages/PWH203/PWH203Form';
import PW2203Form from './pages/PW2203/PW2203Form';
import D205Form from './pages/D205/D205Form';
import C208Form from './pages/C208/C208Form';
import B255Form from './pages/B255/B255Form';
import PWG201Form from './pages/PWG201/PWG201Form';
import G203Form from './pages/G203/G203Form';
import PW9208Form from './pages/PW9208/PW9208Form';
import PWP253Form from './pages/PWP253/PWP253Form';
import PWP252Form from './pages/PWP252/PWP252Form';
import PWP255Form from './pages/PWP255/PWP255Form';
import PWP254Form from './pages/PWP254/PWP254Form';
import PWP211Form from './pages/PWP211/PWP211Form';
import PWJ220Form from './pages/PWJ220/PWJ220Form';
import PWH201Form from './pages/PWH201/PWH201Form';
import PWH204Form from './pages/PWH204/PWH204Form';
import PWH205Form from './pages/PWH205/PWH205Form';
import D214Form from './pages/D214/D214Form';
import PWM202Form from './pages/PWM202/PWM202Form';
import PWT205Form from './pages/PWT205/PWT205Form';
import PWM211Form from './pages/PWM211/PWM211Form';
import PWN201Form from './pages/PWN201/PWN201Form';
import GlobalViewPage from './pages/GlobalView/GlobalViewPage';
import InboxPage from './pages/Inbox';
import C901GForm from './pages/C901G/C901GForm';
import P251Form from './pages/P251/P251Form';
import BatchApprovalPage from './pages/BatchApproval/BatchApprovalPage';
import AuditLogPage from './pages/AuditLog/AuditLogPage';

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider locale={zhTW}>
        <Router>
          <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />

              {/* Full-screen pages (no MainLayout sidebar/header) */}
              <Route path="/module-flow" element={
                <ProtectedRoute>
                  <ModuleFlowPage />
                </ProtectedRoute>
              } />
              
              {/* Protected Routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }>
                {/* Dashboard */}
                <Route index element={<Navigate to="/erp" replace />} />

                {/* ERP */}
                <Route path="erp" element={<ERPHome />} />
                <Route path="erp/global-view" element={<GlobalViewPage />} />

                {/* Inventory Management */}
                <Route path="inventory" element={<Inventory />} />
                
                {/* User Management */}
                <Route path="user" element={<UserList />} />
                <Route path="user/create" element={<UserForm mode="create" />} />
                <Route path="user/edit/:userId" element={<UserForm mode="edit" />} />
                <Route path="user/view/:userId" element={<UserForm mode="view" />} />
                <Route path="user/permissions" element={<PermissionManagement />} />
                <Route path="user/permissions/:userId" element={<UserForm mode="edit" />} />
                <Route path="user/personal-permissions" element={<PersonalPermissionsManagement />} />
                <Route path="user/personal-permissions/:userId" element={<PersonalPermissionEdit />} />
                <Route path="user/monitoring" element={<UserMonitoring />} />
                <Route path="user/change-password" element={<ChangePassword />} />
                
                {/* Permission Demo */}
                <Route path="permission-demo" element={<PermissionDemo />} />
                
                {/* Test Permission V2 API */}
                <Route path="test-permission-v2" element={<TestPermissionV2 />} />
                
                {/* Debug Permissions */}
                <Route path="debug-permissions" element={<DebugPermissions />} />

                {/* Approval List */}
                <Route path="erp/approvals" element={<ApprovalList />} />

                {/* Batch Approval / Writeoff */}
                <Route path="erp/batch-approval" element={<BatchApprovalPage />} />

                {/* Sales Contract (SC) */}
                <Route path="sc" element={<SCForm />} />

                {/* Product Grade (pw1118f1) */}
                <Route path="product-grade" element={<ProductGradeForm />} />

                {/* Complaint Description (pwn102f1) */}
                <Route path="complaint-desc" element={<N102Form />} />
                {/* Office Supplies (pwb151f1) */}
                <Route path="office-supplies" element={<B151Form />} />

                {/* Subcontracting Category (pwd103f1) */}
                <Route path="d103" element={<D103Form />} />

                {/* Exchange Rate (fin_exchangerate) */}
                <Route path="exchange-rate" element={<ExchangeRateForm />} />

                {/* Inventory Movement Category (pwm101f1) */}
                <Route path="inv-move-cat" element={<M101Form />} />

                {/* Company Master (pw1104f1) */}
                <Route path="company" element={<P1104Form />} />

                {/* Inventory Reason (pwm104f1) */}
                <Route path="inv-reason" element={<M104Form />} />

                {/* Department Setup (pw1106f1) */}
                <Route path="dept" element={<P1106Form />} />

                {/* Product Master (pw1113f1) */}
                <Route path="product" element={<P1113Form />} />

                {/* Trade Terms (pw1117f1) */}
                <Route path="trade-terms" element={<P1117Form />} />

                {/* Quality Requirements (pw111hf1) */}
                <Route path="quality-req" element={<P111HForm />} />

                {/* Test Item Setup (pw111af1) */}
                <Route path="test-item" element={<P111AForm />} />

                {/* Material Listing Report (pw1311f1) */}
                <Route path="material-report" element={<P1311Form />} />

                {/* Material Master (pw1111f1) */}
                <Route path="material" element={<P1111Form />} />
                <Route path="payment-terms" element={<P1116Form />} />

                {/* Warehouse Return Statistics (pwd318f1) */}
                <Route path="warehouse-return-stats" element={<D318Report />} />

                {/* Order Follow-up Report (pwc322f1) */}
                <Route path="c322" element={<C322Report />} />

                {/* Sales Return Writeoff (c5m5) */}
                <Route path="c5m5" element={<C5M5Form />} />

                {/* S/C Approval (pwc502f1) */}
                <Route path="c502" element={<C502Approval />} />

                {/* Delivery Order Approval (pwc504f1) */}
                <Route path="c504" element={<C504Approval />} />

                {/* Abnormal Delivery Order Approval (pwc514f1) */}
                <Route path="c514" element={<C514Approval />} />

                {/* Delivery Order Writeoff (pwc5m4f1) */}
                <Route path="c5m4" element={<C5M4Writeoff />} />

                {/* Abnormal DO Approval Writeoff (pwc5n4f1) */}
                <Route path="c5n4" element={<C5N4Writeoff />} />

                {/* Warehouse Return Out Approval (pwd506f1) */}
                <Route path="d506" element={<D506Approval />} />

                {/* Warehouse Return Out (pwd206f1) */}
                <Route path="d206" element={<D206Form />} />

                {/* S/C Writeoff Approval (pwc5m2f1) */}
                <Route path="c5m2" element={<C5M2Form />} />

                {/* Subcontract Receipt Statistics (pwd319f1) */}
                <Route path="d319" element={<D319Form />} />

                {/* Currency Listing Report (pw1308f1) */}
                <Route path="currency-report" element={<P1308Report />} />

                {/* Department Listing Report (pw1306f1) */}
                <Route path="dept-report" element={<P1306Form />} />

                {/* NHI Parameters (pw9137f1) */}
                <Route path="nhi-params" element={<P9137Form />} />

                {/* Employee Group (pw910tf1) */}
                <Route path="emp-group" element={<P910TForm />} />

                {/* Remark (pw110cf1) */}
                <Route path="remark" element={<P110CForm />} />

                {/* Casual Employee Payroll (pw913df1) */}
                <Route path="casual-payroll" element={<P913DForm />} />

                {/* Labor Insurance Parameters (pw9136f1) */}
                <Route path="labor-ins" element={<P9136Form />} />

                {/* Complaint Cause (pwn101f1) */}
                <Route path="complaint-cause" element={<N101Form />} />

                {/* Document Setup (pwl102f1) */}
                <Route path="doc-setup" element={<L102Form />} />

                {/* Inventory Processing Method (pwm105f1) */}
                <Route path="inv-process" element={<M105Form />} />

                {/* Pension Parameters (pw9138f1) */}
                <Route path="pension-params" element={<P9138Form />} />

                {/* Pack Customer (pwp151f1) */}
                <Route path="pack-customer" element={<P151Form />} />

                {/* Pay Item (pw9132f1) */}
                <Route path="pay-item" element={<P9132Form />} />

                {/* Leave Type Setup (pw9108f1) */}
                <Route path="leave-type" element={<P9108Form />} />

                {/* Inspection Method (pw111gf1) */}
                <Route path="insp-method" element={<P111GForm />} />

                {/* Work Schedule (pw910gf1) */}
                <Route path="work-schedule" element={<P910GForm />} />

                {/* VP Approval Priority (pw910jf1) */}
                <Route path="vp-approval-priority" element={<P910JForm />} />

                {/* Vendor Evaluation (pw110hf1) */}
                <Route path="vendor-eval" element={<P110HForm />} />

                {/* Job Grade Definition (pw9103f1) */}
                <Route path="job-grade" element={<P9103Form />} />

                {/* Department Major Definition (pw910qf1) */}
                <Route path="dept-major" element={<P910QForm />} />

                {/* R&D Subcontracting Order Reversal (pwj5n5f1) */}
                <Route path="j5n5" element={<J5N5Reversal />} />

                {/* New-product analysis approval reversal (pwj5n8f1) */}
                <Route path="j5n8" element={<J5N8Reversal />} />

                {/* PO Approval (pwd501f1) */}
                <Route path="d501" element={<D501Form />} />

                {/* Attendance Approval for VP (pw9513f1) */}
                <Route path="p9513" element={<P9513Form />} />

                {/* Color Code Listing Report (pw1314f1) */}
                <Route path="color-report" element={<P1314Report />} />

                {/* Sales Return Detail Report (pwc330f1) */}
                <Route path="c330" element={<C330Form />} />

                {/* Vendor Evaluation Approval (pw15mhf1) */}
                <Route path="p15mh" element={<P15MHApproval />} />

                {/* Vendor Evaluation R&D Approval (pw15mjf1) */}
                <Route path="p15mj" element={<P15MJApproval />} />

                {/* Attendance Status Query (pw9410f1) */}
                <Route path="attendance-status" element={<P9410Form />} />

                {/* Warehouse Return Reversal (pwd5m2f1) */}
                <Route path="d5m2" element={<D5M2Reversal />} />
                <Route
                  path="d5n2"
                  element={<D5M2Reversal api={d5n2Api} manifest={pwd5n2f1AcceptanceManifest} />}
                />

                {/* S/C Closeout Approval (pwc516f1) */}
                <Route path="c516" element={<C516Form />} />

                {/* S/C Closure Reversal (pwc5n6f1) */}
                <Route path="c5n6" element={<C5N6Form />} />

                {/* Warehouse Return Out Reversal (pwr5d6f1) */}
                <Route path="r5d6" element={<R5D6Reversal />} />
                <Route
                  path="d5m6"
                  element={<R5D6Reversal api={d5m6Api} manifest={pwd5m6f1AcceptanceManifest} />}
                />

                {/* Sales Return Writeoff V2 (pwc526f1) */}
                <Route path="c526" element={<C526Form />} />

                {/* Receipt Approval (pwd502f1) */}
                <Route path="d502" element={<D502Form />} />

                {/* Announcement Setup (pwt102f1) */}
                <Route path="announcement" element={<T102Form />} />

                {/* Announcement Application (pwt202f1) */}
                <Route path="t202" element={<T202Form />} />

                {/* Complaint Record - Purchasing (pwn202f1) */}
                <Route path="n202" element={<N202Form />} />

                {/* Inventory Shipment Reversal (pwr5m3f1) */}
                <Route path="r5m3" element={<R5M3Form />} />

                {/* Announcement Approval Reversal (pwt5m2f1) */}
                <Route path="t5m2" element={<T5M2Form />} />

                {/* Announcement Query (pwt402f1) */}
                <Route path="announcement-query" element={<T402Form />} />

                {/* Inventory Adjustment (pwm201f1) */}
                <Route path="m201" element={<M201Form />} />

                {/* Board Number Modification (pwm207f1) */}
                <Route path="m207" element={<M207Form />} />

                {/* Meeting Record (pwt206f1) */}
                <Route path="t206" element={<T206Form />} />

                {/* Requisition Reversal (pwr5d5f1) */}
                <Route path="r5d5" element={<R5D5Form />} />

                {/* Actual Purchase Cost Calculation (pwr211f1) */}
                <Route path="r211" element={<R211Form />} />

                {/* Warehouse Inventory Report (pwm302f1) */}
                <Route path="m302" element={<M302Form />} />

                {/* Negative Inventory Report (pwm310f1) */}
                <Route path="m310" element={<M310Form />} />

                {/* Location Batch Inventory Report (pwm303f1) */}
                <Route path="m303" element={<M303Form />} />

                {/* Complaint Tracking Query (pwn351f1) */}
                <Route path="n351" element={<N351Form />} />

                {/* Consignment Delivery Reversal (pwr5m8f1) */}
                <Route path="r5m8" element={<R5M8Form />} />

                {/* Complaint Approval - Sales Manager (pwn501f1) */}
                <Route path="n501" element={<N501Form />} />

                {/* Complaint Approval - Management Levels (pwn502f1) */}
                <Route path="n502" element={<N502Form />} />

                {/* Complaint Approval - QA (pwn503f1) */}
                <Route path="n503" element={<N503Form />} />

                {/* Inventory Delivery List Reversal (pwm5m3f1) */}
                <Route path="m5m3" element={<M5M3Form />} />

                {/* Inventory Delivery List Entry / Approval (CHAIN-11) */}
                <Route path="m203" element={<M203Form />} />
                <Route path="m503" element={<M503Form />} />

                {/* Inspection Request (pwp201f1) */}
                <Route path="inspection-request" element={<P201Form />} />

                {/* Complaint Purchase Shipment Approval (pwr5npf1) */}
                <Route path="r5np" element={<R5NPForm />} />

                {/* Product Adjustment Reversal (pwm5m1f1) */}
                <Route path="m5m1" element={<M5M1Form />} />

                {/* Consignment Delivery Writeoff (pwm5m8f1) */}
                <Route path="m5m8" element={<M5M8Form />} />

                {/* Complaint Purchase Shipment Reversal (pwn5p1f1) */}
                <Route path="n5p1" element={<N5P1Form />} />

                {/* Receipt Reversal (pwr5d2f1) */}
                <Route path="r5d2" element={<R5D2Reversal />} />

                {/* Physical Test Approval (pwp503f1) */}
                <Route path="p503" element={<P503Form />} />

                {/* Physical Test Approval Reversal (pwp5m3f1) */}
                <Route path="p5m3" element={<P5M3Form />} />

                {/* Total Inventory Report (pwm301f1) */}
                <Route path="m301" element={<M301Form />} />

                {/* Order Batch Inventory Report (pwm305f1) */}
                <Route path="m305" element={<M305Form />} />

                {/* Complaint QA Approval Reversal (pwn5m3f1) */}
                <Route path="n5m3" element={<N5M3Form />} />

                {/* R&D Rack Number Modification (pwm209f1) */}
                <Route path="m209" element={<M209Form />} />

                {/* Sample Request Approval (pwj501f1) */}
                <Route path="j501" element={<J501Form />} />

                {/* R&D PO Approval (pwj514f1) */}
                <Route path="j514" element={<J514Form />} />

                {/* Grade Personnel Listing (pw030af1) */}
                <Route path="pw030a" element={<PW030AForm />} />

                {/* System Usage Log (pw0308f1) */}
                <Route path="pw0308" element={<PW0308Form />} />

                {/* Physical Test Report (pwp203f1) */}
                <Route path="p203" element={<P203Form />} />

                {/* R&D Purchase Order Reversal (pwj5n4f1) */}
                <Route path="j5n4" element={<J5N4Form />} />

                {/* Sample Delivery Reversal (pwj5m3f1) */}
                <Route path="j5m3" element={<J5M3Form />} />

                {/* R&D Warehouse Return Reversal (pwj5m8f1) */}
                <Route path="j5m8" element={<J5M8Form />} />

                {/* Sample Request Approval Reversal (pwj5m1f1) */}
                <Route path="j5m1" element={<J5M1Form />} />

                {/* Document Listing Report (pwl303f1) */}
                <Route path="l303" element={<L303Form />} />

                {/* Document Print/View (pwl313f1) */}
                <Route path="l313" element={<L313Form />} />

                {/* Label Printing (pwj30cf1) */}
                <Route path="j30c" element={<J30CForm />} />

                {/* Inventory Category Maintenance (pwm106f1) */}
                <Route path="m106" element={<M106Form />} />

                {/* Packing Method Maintenance (pw1115f1) */}
                <Route path="pw1115f1" element={<PW1115F1Form />} />

                {/* New Employee Record (pw910cf1) */}
                <Route path="pw910cf1" element={<PW910CF1Form />} />

                {/* Change Password (pw0113f1) */}
                <Route path="pw0113f1" element={<PW0113F1Form />} />

                {/* R&D Subcontract Order Approval (pwj515f1) */}
                <Route path="j515" element={<J515Form />} />

                {/* Document Query (pwl402f1) */}
                <Route path="l402" element={<L402Form />} />

                {/* ISO Document Query (pwl413f1) */}
                <Route path="l413" element={<L413Form />} />

                {/* Chapter Content Maintenance (pwl202f1) */}
                <Route path="l202" element={<L202Form />} />

                {/* R&D Requisition (pwj207f1) */}
                <Route path="j207" element={<J207Form />} />

                {/* Sample Request (pwj201f1) */}
                <Route path="j201" element={<J201Form />} />

                {/* Sample Warehouse Receipt (pwj202f1) */}
                <Route path="j202" element={<J202Form />} />

                {/* Sample Receipt Approval (pwj502f1) */}
                <Route path="j502" element={<J502Form />} />

                {/* R&D Sample Warehouse Receipt (pwj208f1) */}
                <Route path="j208" element={<J208Form />} />

                {/* Sales Album Production (pwj212f1) */}
                <Route path="j212" element={<J212Form />} />

                {/* New Product Dev Analysis (pwj219f1) */}
                <Route path="j219" element={<J219Form />} />

                {/* R&D Purchase Order (pwj214f1) */}
                <Route path="j214" element={<J214Form />} />

                {/* Subcontract Receipt Reversal (pwd5m4f1) */}
                <Route path="d5m4" element={<D5M4Form />} />
                <Route
                  path="d5n4"
                  element={<D5M4Form api={d5n4Api} manifest={pwd5n4f1AcceptanceManifest} />}
                />

                {/* Subcontract Order Reversal (pwd5m3f1) */}
                <Route path="d5m3" element={<D5M3Form />} />

                {/* Purchase Order Approval Reversal (pwd5m1f1) */}
                <Route path="d5m1" element={<D5M1Form />} />

                {/* Sample Receipt Reversal (pwj5m2f1) */}
                <Route path="j5m2" element={<J5M2Form />} />

                {/* Sample Delivery (pwj203f1) */}
                <Route path="j203" element={<J203Form />} />

                {/* Warehouse Location (pw1105f1) */}
                <Route path="warehouse-location" element={<P1105Form />} />

                {/* Color Code Definition (pw1114f1) */}
                <Route path="color-code" element={<P1114Form />} />

                {/* Business Card Personal Data (pw1103f1) */}
                <Route path="business-card" element={<P1103Form />} />

                {/* Employee Master (pw9101f1) */}
                <Route path="employee" element={<P9101Form />} />

                {/* Product Master (prd_product) */}
                <Route path="product-master" element={<PRDForm />} />

                {/* Customer Master (cus_customer) */}
                <Route path="customer" element={<CUSForm />} />

                {/* Quotation Management (pwc201f1) */}
                <Route path="pwc201f1" element={<PWC201F1Form />} />

                {/* Clock In/Out (pw9220f1) */}
                <Route path="pw9220" element={<PW9220Form />} />

                {/* Leave Application (pw9221f1) */}
                <Route path="pw9221f1" element={<PW9221F1Form />} />

                {/* Business Trip Application (pw9224f1) */}
                <Route path="pw9224" element={<PW9224Form />} />

                {/* Bonus Distribution Record (pw9236f1) */}
                <Route path="pw9236f1" element={<PW9236F1Form />} />

                {/* Personnel Transfer (pw9204f1) */}
                <Route path="pw9204f1" element={<PW9204F1Form />} />

                {/* Daily Attendance Record (pw9210f1) */}
                <Route path="pw9210f1" element={<PW9210F1Form />} />

                {/* Sales Return (pw2204f1) */}
                <Route path="pw2204f1" element={<PW2204F1Form />} />

                {/* Batch 10 modules */}
                <Route path="complaint-req" element={<N103Form />} />
                <Route path="defect-cause" element={<P111Form />} />
                <Route path="processing-fee" element={<P1112Form />} />
                <Route path="bonus-def" element={<P9133Form />} />
                <Route path="proc-quality" element={<P111JForm />} />
                <Route path="emp-shortcode" element={<P111KForm />} />
                <Route path="dept-staffing" element={<P9106Form />} />
                <Route path="proxy-setting" element={<P9105Form />} />
                <Route path="job-title" element={<P9102Form />} />
                <Route path="holiday" element={<P910HForm />} />

                {/* Batch 2: 10 modules */}
                <Route path="receivable-detail" element={<G103Form />} />
                <Route path="access-control" element={<P0107Form />} />
                <Route path="accounting-voucher" element={<Chain29VoucherForm />} />
                <Route path="consignment-ship" element={<M208Form />} />
                <Route path="outbound-notice" element={<M206Form />} />
                <Route path="new-product-report" element={<J228Form />} />
                <Route path="salary-adjust" element={<P9234Form />} />
                <Route path="rd-subcontract" element={<J215Form />} />
                <Route path="base-salary" element={<P9232Form />} />
                <Route path="invoice-request" element={<G209Form />} />

                {/* Shipping Order (pwc203f1) */}
                <Route path="shipping-order" element={<C203Form />} />

                {/* Delivery Order (pwc204f1) */}
                <Route path="c204" element={<C204Form />} />

                {/* Sales Return (pwc205f1) */}
                <Route path="c205" element={<C205Form />} />

                {/* Purchase Order (pwd201f1) */}
                <Route path="d201" element={<D201Form />} />

                {/* Warehouse Receipt (pwd202f1) */}
                <Route path="d202" element={<D202Form />} />

                {/* Subcontract Order (pwd203f1) */}
                <Route path="d203" element={<D203Form />} />

                {/* Subcontract Receipt (pwd204f1) */}
                <Route path="d204" element={<D204Form />} />

                {/* Planned Purchase Order (pwd211f1) */}
                <Route path="d211" element={<D211Form />} />

                {/* Planned Subcontract Order (pwd212f1) */}
                <Route path="pwd212" element={<PWD212Form />} />

                {/* Bill/Check Management (fin_billdata) */}
                <Route path="fin-billdata" element={<FinBillDataForm />} />

                {/* Employee Annual Attendance Record (pw9213f1) */}
                <Route path="pw9213" element={<PW9213Form />} />

                {/* Card Custody Registry (pw9119f1) */}
                <Route path="pw9119" element={<PW9119Form />} />

                {/* Job Proxy Change Form (pw9205f1) */}
                <Route path="pw9205" element={<PW9205Form />} />

                {/* Variable Salary Input (pw9233f1) */}
                <Route path="pw9233" element={<PW9233Form />} />

                {/* Staffing Request (pw9201f1) */}
                <Route path="pw9201" element={<PW9201Form />} />

                {/* Department Salary Summary (pw933af1) */}
                <Route path="pw933a" element={<PW933AForm />} />

                {/* Salary Change Detail Report (pw9334f1) */}
                <Route path="pw9334" element={<PW9334Form />} />

                {/* Commission Balance Report (pwg306f1) */}
                <Route path="g306" element={<G306Form />} />

                {/* Shipping/Invoice/Payment Detail Report (pwg319f1) */}
                <Route path="g319" element={<G319Form />} />

                {/* AP Detail Report (pwh301f1) */}
                <Route path="h301" element={<H301Form />} />

                {/* AP Offset Detail Report (pwh303f1) */}
                <Route path="h303" element={<H303Form />} />

                {/* Payment Request Detail Report (pwh311f1) */}
                <Route path="h311" element={<H311Form />} />

                {/* Deferred Payment Invoice Detail Report (pwh312f1) */}
                <Route path="h312" element={<H312Form />} />

                {/* Personal Salary Slip Report (pw9335f1) */}
                <Route path="pw9335" element={<PW9335Form />} />

                {/* Salary Receipt Register (pw9336f1) */}
                <Route path="pw9336" element={<PW9336Form />} />

                {/* Personal Bonus Detail Report (pw9337f1) */}
                <Route path="pw9337" element={<PW9337Form />} />

                {/* Salary Detail Report (pw9339f1) */}
                <Route path="pw9339" element={<PW9339Form />} />

                {/* Salary Disbursement Register (pw933bf1) */}
                <Route path="pw933b" element={<PW933BForm />} />

                {/* Annual Salary Change Report (pw9341f1) */}
                <Route path="pw9341" element={<PW9341Form />} />

                {/* Swipe Attendance Detail Report (pw9311f1) */}
                <Route path="p9311" element={<P9311Form />} />

                {/* Department Personal Attendance Time (pw9315f1) */}
                <Route path="p9315" element={<P9315Form />} />

                {/* Vendor Reconciliation Statement (pwd310f1) */}
                <Route path="pwd310" element={<PWD310Form />} />

                {/* Material-Fabric Mapping Report (pwj310f1) */}
                <Route path="pwj310" element={<PWJ310Form />} />

                {/* Physical Test Report List (pwp303f1) */}
                <Route path="pwp303" element={<PWP303Form />} />

                {/* Leave Monthly Closing (pw9614f1) */}
                <Route path="pw9614" element={<PW9614Form />} />

                {/* Salary Calculation (pw9531f1) */}
                <Route path="pw9531" element={<PW9531Form />} />

                {/* Purchase Receipt Approval (pw2501f1) */}
                <Route path="pw2501" element={<PW2501Form />} />

                {/* Employee Data Query by Department (pw9403f1) */}
                <Route path="pw9403" element={<PW9403Form />} />

                {/* Personal Attendance Status Query (pw9411f1) */}
                <Route path="pw9411" element={<PW9411Form />} />

                {/* Department HR Statistics Report (pw930bf1) */}
                <Route path="pw930b" element={<PW930BForm />} />

                {/* Leave Detail Report (pw9321f1) */}
                <Route path="pw9321" element={<PW9321Form />} />

                {/* HR Notification Print (pw9304f1) */}
                <Route path="pw9304" element={<PW9304Form />} />

                {/* Personal Daily Attendance Detail (pw9310f1) */}
                <Route path="p9310" element={<P9310Form />} />

                {/* Department Staffing Detail Report (pw9306f1) */}
                <Route path="p9306" element={<P9306Form />} />

                {/* Delivery Payment Detail Report (pwg332f1) */}
                <Route path="pwg332" element={<PWG332Form />} />

                {/* Vendor Qualification Approval - GM (pw150kf1) */}
                <Route path="pw150k" element={<PW150KForm />} />

                {/* Vendor Qualification Approval - Department (pw150hf1) */}
                <Route path="pw150h" element={<PW150HForm />} />

                {/* Packing Method List (pw1315f1) */}
                <Route path="pw1315" element={<PW1315Form />} />

                {/* Product List (pw1313f1) */}
                <Route path="pw1313" element={<PW1313Form />} />

                {/* Processing Fee List (pw1312f1) */}
                <Route path="pw1312" element={<PW1312Form />} />

                {/* HR Approval Reversal Portal (pw98m2f1) */}
                <Route path="pw98m2" element={<PW98M2Form />} />

                {/* S/C Detail Report (pwc301f1) */}
                <Route path="pwc301" element={<PWC301Form />} />

                {/* Payment Slip Approval (pwg501f1) */}
                <Route path="pwg501" element={<PWG501Form />} />

                {/* Abnormal Storage Order Approval (pwd512f1) */}
                <Route path="pwd512" element={<PWD512Form />} />

                {/* Sample Delivery Approval Reversal (pwr5j3f1) */}
                <Route path="pwr5j3" element={<PWR5J3Form />} />

                {/* Document Issue List Report (pwl304f1) */}
                <Route path="pwl304" element={<PWL304Form />} />

                {/* R&D Requisition Order Approval Reversal (pwj5m7f1) */}
                <Route path="pwj5m7" element={<PWJ5M7Form />} />

                {/* R&D Storage Order Approval (pwj508f1) */}
                <Route path="pwj508" element={<PWJ508Form />} />

                {/* --- Batch 30 Report Query modules --- */}
                <Route path="pwg302" element={<PWG302Form />} />
                <Route path="g303" element={<G303Form />} />
                <Route path="pwg304" element={<PWG304Form />} />
                <Route path="pwj324" element={<PWJ324Form />} />
                <Route path="pwj308" element={<PWJ308Form />} />
                <Route path="pw9312" element={<PW9312Form />} />
                <Route path="pw9314" element={<PW9314Form_Report />} />
                <Route path="pw9318" element={<PW9318Form />} />
                <Route path="pw9319" element={<PW9319Form />} />
                <Route path="pw9322" element={<PW9322Form />} />
                <Route path="pwd307" element={<PWD307Form />} />
                <Route path="pwd308" element={<PWD308Form />} />
                <Route path="pwj30a" element={<PWJ30AForm />} />
                <Route path="pwj30b" element={<PWJ30BForm />} />

                {/* --- Batch 30 Approval/Writeoff modules --- */}
                <Route path="pw98m5" element={<PW98M5Form />} />
                <Route path="pwc512" element={<PWC512Form />} />
                <Route path="pwd503" element={<PWD503Form />} />
                <Route path="pwr5c4" element={<PWR5C4Form />} />
                <Route path="pwc505" element={<PWC505Form />} />
                <Route path="c505" element={<C505Form />} />
                <Route path="d504" element={<D504Form />} />
                <Route
                  path="d514"
                  element={
                    <D504Form
                      api={d514Api}
                      permissionModule="pwd514f1"
                      manifest={pwd514f1AcceptanceManifest}
                    />
                  }
                />
                <Route path="pwh508" element={<PWH508Form />} />
                <Route path="pwh5m8" element={<PWH5M8Form />} />
                <Route path="pwg5m5" element={<PWG5M5Form />} />
                <Route path="pwg5m1" element={<PWG5M1Form />} />
                <Route path="pwg504" element={<PWG504Form />} />
                <Route path="pwg5m4" element={<PWG5M4Form />} />
                <Route path="pwg5m8" element={<PWG5M8Form />} />
                <Route path="pwj503" element={<PWJ503Form />} />
                <Route path="pwn511" element={<PWN511Form />} />
                <Route path="pwn5ma" element={<PWN5MAForm />} />
                <Route path="pwn5n1" element={<PWN5N1Form />} />
                <Route path="pwn5mb" element={<PWN5MBForm />} />

                {/* ISO Audit Checklist (pwl205f1) */}
                <Route path="l205" element={<L205Form />} />

                {/* ISO Document Page Entry (pwl204f1) */}
                <Route path="l204" element={<L204Form />} />

                {/* Audit Improvement Progress Control (pwl316f1) */}
                <Route path="l316" element={<L316Form />} />

                {/* Board Warehouse Batch Inventory Report (pwm309f1) */}
                <Route path="m309" element={<M309Form />} />

                {/* Complaint Cause Detail Report (pwn301f1) */}
                <Route path="n301" element={<N301Form />} />

                {/* Complaint Factory Purchase/Receipt Delivery Order (pwn211f1) */}
                <Route path="n211" element={<N211Form />} />

                {/* Purchase Order Detail Report (pwd301f1) */}
                <Route path="d301" element={<D301Form />} />

                {/* S/C Profit Analysis Report (pwc358fa) */}
                <Route path="c358" element={<C358Form />} />

                {/* Requisition Detail Report (pwd324f1) */}
                <Route path="d324" element={<D324Form />} />

                {/* Delivery Detail Report (pwc304f1) */}
                <Route path="c304" element={<C304Form />} />

                {/* Company Data Print (pw1304f1) */}
                <Route path="p1304" element={<P1304Form />} />

                {/* Payment Detail Report (pwg305f1) */}
                <Route path="g305" element={<G305Form />} />

                {/* AP Detail Report (pwh302f1) */}
                <Route path="h302" element={<H302Form />} />

                {/* Delivery Reconciliation Report (pwc324f1) */}
                <Route path="c324" element={<C324Form />} />

                {/* Delivery to Warehouse Detail Report (pwd302f1) */}
                <Route path="d302" element={<D302Form />} />

                {/* Delivery Warehouse In/Out Detail Report (pwd312f1) */}
                <Route path="d312" element={<D312Form />} />

                {/* Outsource Order Detail Report - Vendor (pwd303f1) */}
                <Route path="d303" element={<D303Form />} />

                {/* Outsource Warehouse Receipt Detail Report (pwd304f1) */}
                <Route path="d304" element={<D304Form />} />

                {/* Purchase Order Statistics Report (pwd305f1) */}
                <Route path="d305" element={<D305Form />} />

                {/* Delivery Statistics Report (pwc305f1) */}
                <Route path="c305" element={<C305Form />} />

                {/* Delivery Note Summary Report (pwc315f1) */}
                <Route path="pwc315" element={<PWC315Form />} />

                {/* Outsource Order Statistics Report (pwd306f1) */}
                <Route path="d306" element={<D306Form />} />

                {/* Purchase Delivery Date Detail Report (pwd309f1) */}
                <Route path="d309" element={<D309Form />} />

                {/* Fabric Receiving Detail Report (pwd313f1) */}
                <Route path="d313" element={<D313Form />} />

                {/* Purchase Receipt Cost Report (pwd314f1) */}
                <Route path="d314" element={<D314Form />} />

                {/* Vendor Work-Fee Comparison Report (pwd320f1) */}
                <Route path="d320" element={<D320Form />} />

                {/* Abnormal Receipt Memo Report (pwd328f1) */}
                <Route path="d328" element={<D328Form />} />

                {/* Employee Short Code List (pw131kf1) */}
                <Route path="p131k" element={<P131KForm />} />

                {/* Employee Data Report Query (pw9301f1) */}
                <Route path="p9301" element={<P9301Form />} />

                {/* Company Calendar (pw930hf1) */}
                <Route path="p930h" element={<P930HForm />} />

                {/* Annual Leave Summary Report (pw9324f1) */}
                <Route path="pw9324" element={<PW9324Form />} />

                {/* Employee Data Query - GM (pw9404f1) */}
                <Route path="pw9404" element={<PW9404Form />} />

                {/* HR Documents Navigation Menu (pw9701f1) */}
                <Route path="pw9701" element={<PW9701Form />} />

                {/* Normal Inventory Adjustment Approval (pwm501f1) */}
                <Route path="m501" element={<M501Form />} />

                {/* Fabric Inspection Instruction (pwd210f1) */}
                <Route path="pwd210" element={<Pwd210Form />} />

                {/* Receipt Anomaly Explanation - Purchase (pwd216f1) */}
                <Route path="pwd216" element={<Pwd216Form />} />

                {/* Receipt Anomaly Explanation - Supervisor (pwd217f1) */}
                <Route path="pwd217" element={<Pwd217Form />} />

                {/* Cost Calculator */}
                <Route path="cost-calculator" element={<CostCalculator />} />

                {/* Dev Dashboard */}
                <Route path="dev-dashboard" element={<DevDashboard />} />

                {/* MEKAK Knowledge Management - Tabbed Page */}
                <Route path="mekak" element={<MekakPage />} />
                <Route path="mekak/knowledge/create" element={<KnowledgeForm mode="create" />} />
                <Route path="mekak/knowledge/:id" element={<KnowledgeDetail />} />
                <Route path="mekak/knowledge/:id/edit" element={<KnowledgeForm mode="edit" />} />
                <Route path="mekak/files/:id" element={<FileDocumentDetail />} />

                {/* Vendor Meeting Records (pwt207f1) */}
                <Route path="t207" element={<T207Form />} />

                {/* Customer Meeting Records (pwt20af1) */}
                <Route path="t20a" element={<T20AForm />} />

                {/* Sales Allowance (pwg204f1) */}
                <Route path="g204" element={<G204Form />} />

                {/* New Fabric Development Application (pwc209f1) */}
                <Route path="c209" element={<C209Form />} />

                {/* Greige Fabric Forecast (pwc212f1) */}
                <Route path="c212" element={<C212Form />} />

                {/* Purchase Receipt (pw2201f1) */}
                <Route path="p2201" element={<P2201Form />} />

                {/* Purchase Return (pw2202f1) */}
                <Route path="pw2202" element={<PW2202Form />} />

                {/* R&D Inventory Return (pwj209f1) */}
                <Route path="j209" element={<J209Form />} />

                {/* New Product Dev Analysis (pwj218f1) */}
                <Route path="j218" element={<J218Form />} />

                {/* Invoice Application (pwg208f1) */}
                <Route path="pwg208" element={<PWG208Form />} />

                {/* Inventory Adjustment (pw220af1) */}
                <Route path="pw220a" element={<PW220AForm />} />

                {/* Leave Request (pw922af1) */}
                <Route path="p922a" element={<P922AForm />} />

                {/* Resignation Request (pw9207f1) */}
                <Route path="p9207" element={<P9207Form />} />

                {/* Leave of Absence Request (pw9209f1) */}
                <Route path="p9209" element={<P9209Form />} />

                {/* Salary/Expense Writeoff (pwh203f1) */}
                <Route path="pwh203" element={<PWH203Form />} />

                {/* Sales Outbound Order (pw2203f1) */}
                <Route path="pw2203" element={<PW2203Form />} />

                {/* Requisition (pwd205f1) */}
                <Route path="d205" element={<D205Form />} />

                {/* Customer Sample Analysis (pwc208f1) */}
                <Route path="c208" element={<C208Form />} />

                {/* Office Supplies Requisition (pwb255f1) */}
                <Route path="b255" element={<B255Form />} />

                {/* Payment Voucher (pwg201f1) */}
                <Route path="pwg201" element={<PWG201Form />} />

                {/* Severance Notice (pw9208f1) */}
                <Route path="pw9208" element={<PW9208Form />} />

                {/* PACKING-送貨明細 (pwp253f1) */}
                <Route path="pwp253" element={<PWP253Form />} />

                {/* PACKING-貨櫃 (pwp252f1) */}
                <Route path="pwp252" element={<PWP252Form />} />

                {/* 出貨包裝單 Packing List (pwp254f1) */}
                <Route path="pwp254" element={<PWP254Form />} />

                {/* PACKING LIST 客戶資料-貨櫃 (pwp255f1) */}
                <Route path="pwp255" element={<PWP255Form />} />

                {/* 外觀檢驗（驗布）(pwp211f1) */}
                <Route path="pwp211" element={<PWP211Form />} />

                {/* 新產品開發分析單（雙或多層織物）(pwj220f1) */}
                <Route path="pwj220" element={<PWJ220Form />} />

                {/* 請款單 (pwh201f1) */}
                <Route path="pwh201" element={<PWH201Form />} />

                {/* 進貨折讓單 (pwh204f1) */}
                <Route path="pwh204" element={<PWH204Form />} />

                {/* 暫借款請款單 (pwh205f1) */}
                <Route path="pwh205" element={<PWH205Form />} />

                {/* 生產排程管理 (pwd214f1) */}
                <Route path="d214" element={<D214Form />} />

                {/* 庫位移轉單 (pwm202f1) */}
                <Route path="pwm202" element={<PWM202Form />} />

                {/* 會議記錄管理 (pwt205f1) */}
                <Route path="pwt205" element={<PWT205Form />} />

                {/* 庫位狀況回覆作業 (pwm211f1) */}
                <Route path="pwm211" element={<PWM211Form />} />

                {/* 客訴處理記錄 (pwn201f1) */}
                <Route path="pwn201" element={<PWN201Form />} />

                {/* 應收帳款回覆作業 (pwg203f1) */}
                <Route path="g203" element={<G203Form />} />

                {/* Inbox */}
                <Route path="inbox" element={<InboxPage />} />

                {/* Sales Audit Tool (pwc901fg) */}
                <Route path="c901g" element={<C901GForm />} />

                {/* 內外銷PACKING LIST (pwp251f1) */}
                <Route path="pwp251" element={<P251Form />} />

                {/* 稽核記錄查詢 (sys_auditlog，僅管理者群組) */}
                <Route path="audit-log" element={<AuditLogPage />} />

                {/* Catch all - redirect to dashboard */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </AuthProvider>
        </Router>
      </ConfigProvider>
    </ErrorBoundary>
  );
}

export default App;
